import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import Spinner from "@/components/ui/spinner";

function LoadingFallback() {
  return <Spinner wrapperClassName="mt-5 pt-5 w-100" />;
}

function SuspenseWrapper() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Outlet />
    </Suspense>
  );
}

export default SuspenseWrapper;
